import { PhotoGsd    } from "./Network"; 
import { AbandonedVehicleReviewStatus    } from "./Network"; 
import { AbandonedVehicleStatus    } from "./Network"; 
import { PasswordResetType    } from "./Network"; 
import { VehicleSituation    } from "./Network"; import { AerialImageApi } from "./Network"; 
import { AerialImagePairOffsetApi } from "./Network"; 
import { AiStructuredResponseApi } from "./Network"; 
import { CadModelAttributesApi } from "./Network"; 
import { CadModelApi } from "./Network"; 
import { ChicagoAbandonedVehicleApi } from "./Network"; 
import { CreateAerialImageApi } from "./Network"; 
import { DatasetApi } from "./Network"; 
import { DatasetImageApi } from "./Network"; 
import { DatasetStatsApi } from "./Network"; 
import { DumpTrainingDataRespApi } from "./Network"; 
import { EmployeeApi } from "./Network"; 
import { LoginResponseApi } from "./Network"; 
import { MunicipalityApi } from "./Network"; 
import { ObbAnnotationAttributesApi } from "./Network"; 
import { ObbAnnotationApi } from "./Network"; 
import { ObbClassApi } from "./Network"; 
import { ObbDetApi } from "./Network"; 
import { ObbDetCompApi } from "./Network"; 
import { ObbModelApi } from "./Network"; 
import { AbandonedVehicleRunApi } from "./Network"; 
import { ObbRunApi } from "./Network"; 
import { RepoAddressApi } from "./Network"; 
import { RepoSearchReqApi } from "./Network"; 
import { RepoSearchRespApi } from "./Network"; 
import { VehicleDataApi } from "./Network"; 
import { AddressDataApi } from "./Network"; 
import { DateTestApi } from "./Network"; 
import { ResolvedAddressApi } from "./Network"; 
import { UpdateAerialImageApi } from "./Network"; 
import { VehicleApi } from "./Network"; 
import { AbandonedVehicleApi } from "./Network"; 
import { AbandonedVehicleAttributesApi } from "./Network"; 
import { AbandonedVehicleAttributesCompressedApi } from "./Network"; 
import { AbandonedVehicleChangeApi } from "./Network"; 
import { AbandonedVehicleChangeCompressedApi } from "./Network"; 
import { AbandonedVehicleCompressedApi } from "./Network"; 
import { AbandonedVehicleReviewChangeApi } from "./Network"; 
import { AbandonedVehicleReviewChangeCompressedApi } from "./Network"; 
import { AbandonedVehicleUpdateReqApi } from "./Network"; 
import { AbandonedVehicleReviewUpdateReqApi } from "./Network"; 
import { AbandonedVehicleUpdateAttrReqApi } from "./Network"; 
import { AbandonedVehicleCreateReqApi } from "./Network"; 
import { LoginReqApi } from "./Network"; 
import { RegisterReqApi } from "./Network"; 
import { ForgotPasswordReqApi } from "./Network"; 
import { ResetPasswordReqApi } from "./Network"; 
import { ChangePasswordReqApi } from "./Network"; 
import { ChangeEmailReqApi } from "./Network"; 
import { ChangeNameReqApi } from "./Network"; 
import { LoginRespApi } from "./Network"; 
import { ResetPasswordCheckReqApi } from "./Network"; 
import { CadModelUpdateAttributesReqApi } from "./Network"; 
import { DatasetCreateReqApi } from "./Network"; 
import { DatasetRespApi } from "./Network"; 
import { DatasetImageAddRespApi } from "./Network"; 
import { DatasetImageObjectAddReqApi } from "./Network"; 
import { TileAerialImageReqApi } from "./Network"; 
import { TleRecApi } from "./Network"; 
import { SatelliteInfoApi } from "./Network"; 
import { TleReqApi } from "./Network"; 
import { TileResponseApi } from "./Network"; import { AerialImage } from "./Application"; 
import { AerialImagePairOffset } from "./Application"; 
import { AiStructuredResponse } from "./Application"; 
import { CadModelAttributes } from "./Application"; 
import { CadModel } from "./Application"; 
import { ChicagoAbandonedVehicle } from "./Application"; 
import { CreateAerialImage } from "./Application"; 
import { Dataset } from "./Application"; 
import { DatasetImage } from "./Application"; 
import { DatasetStats } from "./Application"; 
import { DumpTrainingDataResp } from "./Application"; 
import { Employee } from "./Application"; 
import { LoginResponse } from "./Application"; 
import { Municipality } from "./Application"; 
import { ObbAnnotationAttributes } from "./Application"; 
import { ObbAnnotation } from "./Application"; 
import { ObbClass } from "./Application"; 
import { ObbDet } from "./Application"; 
import { ObbDetComp } from "./Application"; 
import { ObbModel } from "./Application"; 
import { AbandonedVehicleRun } from "./Application"; 
import { ObbRun } from "./Application"; 
import { RepoAddress } from "./Application"; 
import { RepoSearchReq } from "./Application"; 
import { RepoSearchResp } from "./Application"; 
import { VehicleData } from "./Application"; 
import { AddressData } from "./Application"; 
import { DateTest } from "./Application"; 
import { ResolvedAddress } from "./Application"; 
import { UpdateAerialImage } from "./Application"; 
import { Vehicle } from "./Application"; 
import { AbandonedVehicle } from "./Application"; 
import { AbandonedVehicleAttributes } from "./Application"; 
import { AbandonedVehicleAttributesCompressed } from "./Application"; 
import { AbandonedVehicleChange } from "./Application"; 
import { AbandonedVehicleChangeCompressed } from "./Application"; 
import { AbandonedVehicleCompressed } from "./Application"; 
import { AbandonedVehicleReviewChange } from "./Application"; 
import { AbandonedVehicleReviewChangeCompressed } from "./Application"; 
import { AbandonedVehicleUpdateReq } from "./Application"; 
import { AbandonedVehicleReviewUpdateReq } from "./Application"; 
import { AbandonedVehicleUpdateAttrReq } from "./Application"; 
import { AbandonedVehicleCreateReq } from "./Application"; 
import { LoginReq } from "./Application"; 
import { RegisterReq } from "./Application"; 
import { ForgotPasswordReq } from "./Application"; 
import { ResetPasswordReq } from "./Application"; 
import { ChangePasswordReq } from "./Application"; 
import { ChangeEmailReq } from "./Application"; 
import { ChangeNameReq } from "./Application"; 
import { LoginResp } from "./Application"; 
import { ResetPasswordCheckReq } from "./Application"; 
import { CadModelUpdateAttributesReq } from "./Application"; 
import { DatasetCreateReq } from "./Application"; 
import { DatasetResp } from "./Application"; 
import { DatasetImageAddResp } from "./Application"; 
import { DatasetImageObjectAddReq } from "./Application"; 
import { TileAerialImageReq } from "./Application"; 
import { TleRec } from "./Application"; 
import { SatelliteInfo } from "./Application"; 
import { TleReq } from "./Application"; 
import { TileResponse } from "./Application"; 
import { emitInstant,emitLocalDate,emitLocalTime,emitLocalDateTime,emitDuration } from "./Converters";
export function emitAerialImage( x: AerialImage ): AerialImageApi {
    return {
        aerialImageId: x.aerialImageId,
        aerialProviderId: x.aerialProviderId,
        name: x.name,
        filePath: x.filePath,
        fileSize: x.fileSize,
        contentType: x.contentType,
        capturedWhen: emitInstant( x.capturedWhen ),
        originX: x.originX,
        pixelWidth: x.pixelWidth,
        rotationX: x.rotationX,
        originY: x.originY,
        rotationY: x.rotationY,
        pixelHeight: x.pixelHeight,
        epsgCode: x.epsgCode,
        width: x.width,
        height: x.height,
        minX: x.minX,
        minY: x.minY,
        maxX: x.maxX,
        maxY: x.maxY,
    }
}

export function emitAerialImagePairOffset( x: AerialImagePairOffset ): AerialImagePairOffsetApi {
    return {
        aerialImagePairOffsetId: x.aerialImagePairOffsetId,
        aerialImageBeforeId: x.aerialImageBeforeId,
        aerialImageAfterId: x.aerialImageAfterId,
        offsetX: x.offsetX,
        offsetY: x.offsetY,
    }
}

export function emitAiStructuredResponse( x: AiStructuredResponse ): AiStructuredResponseApi {
    return {
        vehicle: emitVehicle( x.vehicle ),
        addresses: x.addresses.map( el => emitRepoAddress( el ) ),
    }
}

export function emitCadModelAttributes( x: CadModelAttributes ): CadModelAttributesApi {
    return {
        vehicleType: x.vehicleType != null ? x.vehicleType : null,
    }
}

export function emitCadModel( x: CadModel ): CadModelApi {
    return {
        id: x.id,
        modelId: x.modelId,
        collectionId: x.collectionId,
        modelName: x.modelName != null ? x.modelName : null,
        description: x.description != null ? x.description : null,
        issue: x.issue != null ? x.issue : null,
        carMake: x.carMake != null ? x.carMake : null,
        carYear: x.carYear != null ? x.carYear : null,
        carModel: x.carModel != null ? x.carModel : null,
        dimsL: x.dimsL != null ? x.dimsL : null,
        dimsW: x.dimsW != null ? x.dimsW : null,
        dimsH: x.dimsH != null ? x.dimsH : null,
        color: x.color != null ? x.color : null,
        domain: x.domain != null ? x.domain : null,
        type1: x.type1 != null ? x.type1 : null,
        url: x.url != null ? x.url : null,
        error: x.error != null ? x.error : null,
        comment: x.comment != null ? x.comment : null,
        attributes: emitCadModelAttributes( x.attributes ),
    }
}

export function emitChicagoAbandonedVehicle( x: ChicagoAbandonedVehicle ): ChicagoAbandonedVehicleApi {
    return {
        lat: x.lat != null ? x.lat : null,
        lng: x.lng != null ? x.lng : null,
        date: x.date != null ? emitInstant( x.date ) : null,
    }
}

export function emitCreateAerialImage( x: CreateAerialImage ): CreateAerialImageApi {
    return {
        fileName: x.fileName,
        filePath: x.filePath,
        location: x.location,
        capturedAt: x.capturedAt != null ? emitInstant( x.capturedAt ) : null,
        resolution: x.resolution,
        width: x.width,
        height: x.height,
        fileSize: x.fileSize,
        tags: x.tags != null ? x.tags.map( el => el ) : null,
    }
}

export function emitDataset( x: Dataset ): DatasetApi {
    return {
        datasetId: x.datasetId,
        name: x.name,
        description: x.description != null ? x.description : null,
        count: x.count,
    }
}

export function emitDatasetImage( x: DatasetImage ): DatasetImageApi {
    return {
        datasetImageId: x.datasetImageId,
        datasetId: x.datasetId,
        name: x.name,
        filePath: x.filePath,
        width: x.width,
        height: x.height,
        objectCount: x.objectCount,
        annotatedCount: x.annotatedCount,
        epsgCode: x.epsgCode != null ? x.epsgCode : null,
        originX: x.originX != null ? x.originX : null,
        originY: x.originY != null ? x.originY : null,
        pixelWidth: x.pixelWidth != null ? x.pixelWidth : null,
        pixelHeight: x.pixelHeight != null ? x.pixelHeight : null,
        rotationX: x.rotationX != null ? x.rotationX : null,
        rotationY: x.rotationY != null ? x.rotationY : null,
        minX: x.minX != null ? x.minX : null,
        minY: x.minY != null ? x.minY : null,
        maxX: x.maxX != null ? x.maxX : null,
        maxY: x.maxY != null ? x.maxY : null,
    }
}

export function emitDatasetStats( x: DatasetStats ): DatasetStatsApi {
    return {
        datasetId: x.datasetId,
        imageCount: x.imageCount,
        vehicleCount: x.vehicleCount,
        vehicleTypeStats: x.vehicleTypeStats.map( el => el ),
        vehicleColorStats: x.vehicleColorStats.map( el => el ),
    }
}

export function emitDumpTrainingDataResp( x: DumpTrainingDataResp ): DumpTrainingDataRespApi {
    return {
        classCounts: x.classCounts.map( el => el ),
        total: x.total,
        errors: x.errors,
    }
}

export function emitEmployee( x: Employee ): EmployeeApi {
    return {
        employeeId: x.employeeId,
        municipalityId: x.municipalityId,
        emailAddress: x.emailAddress,
        name: x.name,
        municipality: emitMunicipality( x.municipality ),
    }
}

export function emitLoginResponse( x: LoginResponse ): LoginResponseApi {
    return {
        token: x.token,
        employee: emitEmployee( x.employee ),
    }
}

export function emitMunicipality( x: Municipality ): MunicipalityApi {
    return {
        municipalityId: x.municipalityId,
        name: x.name,
    }
}

export function emitObbAnnotationAttributes( x: ObbAnnotationAttributes ): ObbAnnotationAttributesApi {
    return {
        classLabel: x.classLabel != null ? x.classLabel : null,
        vehicleType: x.vehicleType != null ? x.vehicleType : null,
        color: x.color != null ? x.color : null,
        parts: x.parts != null ? x.parts.map( el => el ) : null,
        shade: x.shade != null ? x.shade : null,
        occluded: x.occluded != null ? x.occluded : null,
        rare: x.rare != null ? x.rare : null,
    }
}

export function emitObbAnnotation( x: ObbAnnotation ): ObbAnnotationApi {
    return {
        obbAnnotationId: x.obbAnnotationId,
        datasetImageId: x.datasetImageId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        attributes: emitObbAnnotationAttributes( x.attributes ),
    }
}

export function emitObbClass( x: ObbClass ): ObbClassApi {
    return {
        obbClassId: x.obbClassId,
        name: x.name,
    }
}

export function emitObbDet( x: ObbDet ): ObbDetApi {
    return {
        obbDetId: x.obbDetId,
        obbRunId: x.obbRunId,
        obbModelId: x.obbModelId,
        obbClassId: x.obbClassId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        confidence: x.confidence,
    }
}

export function emitObbDetComp( x: ObbDetComp ): ObbDetCompApi {
    return {
        id: x.id,
        cls: x.cls,
        x: x.x,
        y: x.y,
        w: x.w,
        h: x.h,
        a: x.a,
        c: x.c,
    }
}

export function emitObbModel( x: ObbModel ): ObbModelApi {
    return {
        obbModelId: x.obbModelId,
        name: x.name,
    }
}

export function emitAbandonedVehicleRun( x: AbandonedVehicleRun ): AbandonedVehicleRunApi {
    return {
        abandonedVehicleRunId: x.abandonedVehicleRunId,
        aerialImageBeforeId: x.aerialImageBeforeId,
        aerialImageAfterId: x.aerialImageAfterId,
        before: emitAerialImage( x.before ),
        after: emitAerialImage( x.after ),
        createdWhen: emitInstant( x.createdWhen ),
    }
}

export function emitObbRun( x: ObbRun ): ObbRunApi {
    return {
        obbRunId: x.obbRunId,
        aerialImageId: x.aerialImageId,
        obbModelId: x.obbModelId,
        createdByEmployeeId: x.createdByEmployeeId,
        createdWhen: emitInstant( x.createdWhen ),
        notes: x.notes != null ? x.notes : null,
    }
}

export function emitRepoAddress( x: RepoAddress ): RepoAddressApi {
    return {
        addressLine1: x.addressLine1,
        addressLine2: x.addressLine2,
        city: x.city,
        state: x.state,
        zipCode: x.zipCode,
    }
}

export function emitRepoSearchReq( x: RepoSearchReq ): RepoSearchReqApi {
    return {
        vehiclePrompt: x.vehiclePrompt,
        addressesPrompt: x.addressesPrompt,
    }
}

export function emitRepoSearchResp( x: RepoSearchResp ): RepoSearchRespApi {
    return {
        vehicle: emitVehicleData( x.vehicle ),
        addresses: x.addresses.map( el => emitAddressData( el ) ),
    }
}

export function emitVehicleData( x: VehicleData ): VehicleDataApi {
    return {
        make: x.make,
        model: x.model,
        color: x.color != null ? x.color : null,
        year: x.year != null ? x.year : null,
    }
}

export function emitAddressData( x: AddressData ): AddressDataApi {
    return {
        streetNumber: x.streetNumber != null ? x.streetNumber : null,
        street: x.street != null ? x.street : null,
        city: x.city != null ? x.city : null,
        state: x.state != null ? x.state : null,
        postalCode: x.postalCode != null ? x.postalCode : null,
    }
}

export function emitDateTest( x: DateTest ): DateTestApi {
    return {
        when: emitInstant( x.when ),
        when1: emitLocalDate( x.when1 ),
        when2: emitLocalTime( x.when2 ),
        when3: emitLocalDateTime( x.when3 ),
        dur1: emitDuration( x.dur1 ),
    }
}

export function emitResolvedAddress( x: ResolvedAddress ): ResolvedAddressApi {
    return {
        addressId: x.addressId,
        fullAddress: x.fullAddress,
        streetNumber: x.streetNumber != null ? x.streetNumber : null,
        street: x.street != null ? x.street : null,
        city: x.city != null ? x.city : null,
        state: x.state != null ? x.state : null,
        postalCode: x.postalCode != null ? x.postalCode : null,
        country: x.country != null ? x.country : null,
        latitude: x.latitude != null ? x.latitude : null,
        longitude: x.longitude != null ? x.longitude : null,
        resolvedWhen: emitInstant( x.resolvedWhen ),
    }
}

export function emitUpdateAerialImage( x: UpdateAerialImage ): UpdateAerialImageApi {
    return {
        location: x.location != null ? x.location : null,
        processingStatus: x.processingStatus != null ? x.processingStatus : null,
        tags: x.tags != null ? x.tags.map( el => el ) : null,
    }
}

export function emitVehicle( x: Vehicle ): VehicleApi {
    return {
        vehicleId: x.vehicleId,
        make: x.make,
        model: x.model,
        color: x.color != null ? x.color : null,
        year: x.year != null ? x.year : null,
    }
}

export function emitAbandonedVehicle( x: AbandonedVehicle ): AbandonedVehicleApi {
    return {
        abandonedVehicleId: x.abandonedVehicleId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        confidence: x.confidence,
        similarity: x.similarity,
        status: emitAbandonedVehicleChange( x.status ),
        reviewStatus: x.reviewStatus != null ? emitAbandonedVehicleReviewChange( x.reviewStatus ) : null,
        note: x.note,
        attributes: emitAbandonedVehicleAttributes( x.attributes ),
        changes: x.changes.map( el => emitAbandonedVehicleChange( el ) ),
        reviews: x.reviews.map( el => emitAbandonedVehicleReviewChange( el ) ),
    }
}

export function emitAbandonedVehicleAttributes( x: AbandonedVehicleAttributes ): AbandonedVehicleAttributesApi {
    return {
        landUse: x.landUse != null ? x.landUse : null,
        vehicleType: x.vehicleType != null ? x.vehicleType : null,
        situation: x.situation != null ? x.situation : null,
        area: x.area != null ? x.area : null,
        address: x.address != null ? x.address : null,
    }
}

export function emitAbandonedVehicleAttributesCompressed( x: AbandonedVehicleAttributesCompressed ): AbandonedVehicleAttributesCompressedApi {
    return {
        lu: x.lu != null ? x.lu : null,
        vt: x.vt != null ? x.vt : null,
        si: x.si != null ? x.si : null,
        ar: x.ar != null ? x.ar : null,
        ad: x.ad != null ? x.ad : null,
    }
}

export function emitAbandonedVehicleChange( x: AbandonedVehicleChange ): AbandonedVehicleChangeApi {
    return {
        abandonedVehicleChangeId: x.abandonedVehicleChangeId,
        abandonedVehicleId: x.abandonedVehicleId,
        note: x.note,
        status: x.status,
        createdWhen: emitInstant( x.createdWhen ),
        createdBy: x.createdBy != null ? emitEmployee( x.createdBy ) : null,
    }
}

export function emitAbandonedVehicleChangeCompressed( x: AbandonedVehicleChangeCompressed ): AbandonedVehicleChangeCompressedApi {
    return {
        c: x.c,
        d: emitInstant( x.d ),
    }
}

export function emitAbandonedVehicleCompressed( x: AbandonedVehicleCompressed ): AbandonedVehicleCompressedApi {
    return {
        a: x.a,
        x: x.x,
        y: x.y,
        w: x.w,
        h: x.h,
        t: x.t,
        c: x.c,
        s: x.s,
        at: emitAbandonedVehicleAttributesCompressed( x.at ),
        st: emitAbandonedVehicleChangeCompressed( x.st ),
        rs: x.rs != null ? emitAbandonedVehicleReviewChangeCompressed( x.rs ) : null,
    }
}

export function emitAbandonedVehicleReviewChange( x: AbandonedVehicleReviewChange ): AbandonedVehicleReviewChangeApi {
    return {
        abandonedVehicleReviewChangeId: x.abandonedVehicleReviewChangeId,
        abandonedVehicleId: x.abandonedVehicleId,
        note: x.note,
        status: x.status,
        createdWhen: emitInstant( x.createdWhen ),
        createdBy: emitEmployee( x.createdBy ),
    }
}

export function emitAbandonedVehicleReviewChangeCompressed( x: AbandonedVehicleReviewChangeCompressed ): AbandonedVehicleReviewChangeCompressedApi {
    return {
        c: x.c,
        d: emitInstant( x.d ),
    }
}

export function emitAbandonedVehicleUpdateReq( x: AbandonedVehicleUpdateReq ): AbandonedVehicleUpdateReqApi {
    return {
        note: x.note,
        status: x.status,
    }
}

export function emitAbandonedVehicleReviewUpdateReq( x: AbandonedVehicleReviewUpdateReq ): AbandonedVehicleReviewUpdateReqApi {
    return {
        note: x.note,
        status: x.status,
    }
}

export function emitAbandonedVehicleUpdateAttrReq( x: AbandonedVehicleUpdateAttrReq ): AbandonedVehicleUpdateAttrReqApi {
    return {
        situation: x.situation != null ? x.situation : null,
    }
}

export function emitAbandonedVehicleCreateReq( x: AbandonedVehicleCreateReq ): AbandonedVehicleCreateReqApi {
    return {
        runId: x.runId,
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
    }
}

export function emitLoginReq( x: LoginReq ): LoginReqApi {
    return {
        emailAddress: x.emailAddress,
        password: x.password,
    }
}

export function emitRegisterReq( x: RegisterReq ): RegisterReqApi {
    return {
        businessId: x.businessId,
        emailAddress: x.emailAddress,
        name: x.name,
        password: x.password,
        note: x.note,
    }
}

export function emitForgotPasswordReq( x: ForgotPasswordReq ): ForgotPasswordReqApi {
    return {
        emailAddress: x.emailAddress,
    }
}

export function emitResetPasswordReq( x: ResetPasswordReq ): ResetPasswordReqApi {
    return {
        email: x.email,
        resetCode: x.resetCode,
        newPassword: x.newPassword,
    }
}

export function emitChangePasswordReq( x: ChangePasswordReq ): ChangePasswordReqApi {
    return {
        currentPassword: x.currentPassword,
        newPassword: x.newPassword,
    }
}

export function emitChangeEmailReq( x: ChangeEmailReq ): ChangeEmailReqApi {
    return {
        currentPassword: x.currentPassword,
        newEmailAddress: x.newEmailAddress,
    }
}

export function emitChangeNameReq( x: ChangeNameReq ): ChangeNameReqApi {
    return {
        name: x.name,
    }
}

export function emitLoginResp( x: LoginResp ): LoginRespApi {
    return {
        token: x.token,
        employee: emitEmployee( x.employee ),
    }
}

export function emitResetPasswordCheckReq( x: ResetPasswordCheckReq ): ResetPasswordCheckReqApi {
    return {
        resetCode: x.resetCode,
    }
}

export function emitCadModelUpdateAttributesReq( x: CadModelUpdateAttributesReq ): CadModelUpdateAttributesReqApi {
    return {
        attributes: emitCadModelAttributes( x.attributes ),
    }
}

export function emitDatasetCreateReq( x: DatasetCreateReq ): DatasetCreateReqApi {
    return {
        name: x.name,
        description: x.description != null ? x.description : null,
    }
}

export function emitDatasetResp( x: DatasetResp ): DatasetRespApi {
    return {
        datasetId: x.datasetId,
        name: x.name,
        description: x.description != null ? x.description : null,
    }
}

export function emitDatasetImageAddResp( x: DatasetImageAddResp ): DatasetImageAddRespApi {
    return {
        datasetImageId: x.datasetImageId,
    }
}

export function emitDatasetImageObjectAddReq( x: DatasetImageObjectAddReq ): DatasetImageObjectAddReqApi {
    return {
        x: x.x,
        y: x.y,
        width: x.width,
        height: x.height,
        angle: x.angle,
        attributes: emitObbAnnotationAttributes( x.attributes ),
    }
}

export function emitTileAerialImageReq( x: TileAerialImageReq ): TileAerialImageReqApi {
    return {
        aerialImageId: x.aerialImageId,
        datasetName: x.datasetName,
        tileSize: x.tileSize,
        overlapPercentage: x.overlapPercentage,
    }
}

export function emitTleRec( x: TleRec ): TleRecApi {
    return {
        twoLineElementId: x.twoLineElementId,
        satelliteId: x.satelliteId,
        noradCatId: x.noradCatId,
        epoch: emitInstant( x.epoch ),
        line1: x.line1,
        line2: x.line2,
    }
}

export function emitSatelliteInfo( x: SatelliteInfo ): SatelliteInfoApi {
    return {
        satelliteId: x.satelliteId,
        noradCatId: x.noradCatId,
        name: x.name,
    }
}

export function emitTleReq( x: TleReq ): TleReqApi {
    return {
        noradCatIds: x.noradCatIds.map( el => el ),
    }
}

export function emitTileResponse( x: TileResponse ): TileResponseApi {
    return {
        message: x.message,
        tilesGenerated: x.tilesGenerated,
        tilesSkipped: x.tilesSkipped,
        outputPath: x.outputPath,
        zoomLevels: x.zoomLevels,
        minZoom: x.minZoom,
        maxZoom: x.maxZoom,
        imageWidth: x.imageWidth,
        imageHeight: x.imageHeight,
    }
}
